'use strict'

module.exports = {
    project_name: 'hanland',
    package_name: 'hanland',
    port: 8000,
    url: 'https://manage.uziliving.com'
}
